import PropTypes from 'prop-types'

import CardRatingBody from './CardRatingBody.js'
import CardRatingHeader from './CardRatingHeader.js'

const CardRatingReply = ({isOwner, message, ratingTargetName, replyDate}) => {
  return (
    <div className="mt-CardRating mt-CardRating-reply" data-testid="card-rating-reply">
      <CardRatingHeader
        reviewDate={replyDate}
        reviewerName={`${isOwner ? 'Tu' : ratingTargetName} respuesta:`}
        showAvatar={false}
        showRating={false}
      />
      <CardRatingBody message={message} />
    </div>
  )
}

CardRatingReply.displayName = 'CardRatingReply'

CardRatingReply.propTypes = {
  isOwner: PropTypes.bool,
  message: PropTypes.string,
  ratingTargetName: PropTypes.string,
  replyDate: PropTypes.string
}

export default CardRatingReply
